var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageAccessEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1616355",
    "data-name": "Group 1616355",
    transform: "translate(-856 -412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6956",
    "data-name": "Path 6956",
    d: "M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Z",
    transform: "translate(856 412)",
    fill: "#165cf3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6",
    d: "M6.647,2.629a.583.583,0,0,1,.541-.078,3.857,3.857,0,0,1,1.151.666.584.584,0,0,1,.2.507,1.342,1.342,0,0,0,.162.813,1.318,1.318,0,0,0,.537.5l.087.042a.583.583,0,0,1,.338.43,3.9,3.9,0,0,1,0,1.328.58.58,0,0,1-.291.406l-.047.024a1.29,1.29,0,0,0-.786,1.36.584.584,0,0,1-.2.507A3.857,3.857,0,0,1,7.187,9.8a.583.583,0,0,1-.541-.078,1.29,1.29,0,0,0-1.572,0,.583.583,0,0,1-.541.078,3.856,3.856,0,0,1-1.151-.666.583.583,0,0,1-.2-.507,1.342,1.342,0,0,0-.162-.813,1.318,1.318,0,0,0-.537-.5L2.4,7.272a.583.583,0,0,1-.338-.43,3.9,3.9,0,0,1,0-1.328.58.58,0,0,1,.291-.406L2.4,5.084a1.29,1.29,0,0,0,.786-1.36.584.584,0,0,1,.2-.507,3.857,3.857,0,0,1,1.151-.666.583.583,0,0,1,.541.078,1.29,1.29,0,0,0,1.572,0Zm.369.683a2.052,2.052,0,0,1-2.31,0,3.085,3.085,0,0,0-.749.433,2.052,2.052,0,0,1-1.155,2,3.133,3.133,0,0,0,0,.866,2.052,2.052,0,0,1,1.155,2,3.084,3.084,0,0,0,.749.433,2.052,2.052,0,0,1,2.31,0,3.086,3.086,0,0,0,.749-.433,2.052,2.052,0,0,1,1.155-2,3.132,3.132,0,0,0,0-.865,2.052,2.052,0,0,1-1.155-2A3.085,3.085,0,0,0,7.016,3.312ZM5.861,4.634A1.544,1.544,0,1,1,4.316,6.178,1.544,1.544,0,0,1,5.861,4.634Zm0,.772a.772.772,0,1,0,.772.772A.772.772,0,0,0,5.861,5.406Z",
    transform: "translate(866 420.357)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1984",
    d: "M.6,13.34V12.007A2.67,2.67,0,0,1,3.267,9.34H4.989",
    transform: "translate(862.075 415.607)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_201",
    cx: 2.667,
    cy: 2.667,
    rx: 2.667,
    ry: 2.667,
    transform: "translate(865.333 416.964)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageAccessEditIcon);
export default __webpack_public_path__ + "static/media/manage-access-edit-icon.0e0983e6375ba74102c8c3aef3bdb776.svg";
export { ForwardRef as ReactComponent };